import type { AboutContent } from "../types";
import { renderSectionHeader } from "./section-header";

export function renderAbout(about: AboutContent): string {
  const paras = about.paragraphs.map((p) => `<p>${p}</p>`).join("");
  const stats = about.stats
    .map(
      (s, i) => `
      <div class="stat" data-reveal style="--i:${i}">
        <div class="stat-value">${s.value}</div>
        <div class="stat-label">${s.label}</div>
      </div>`,
    )
    .join("");

  return `
    <section class="section" id="${about.id}">
      ${renderSectionHeader(about.header)}
      <div class="about">
        <div class="about-text" data-reveal>${paras}</div>
        <div class="stats">${stats}</div>
      </div>
    </section>`;
}
